import SingleSelect from 'components/inputs/dropdowns/SingleSelect';
import { SelectOption } from 'components/inputs/BaseSelect';
import React, { useState } from 'react';
import { IRegionalConfig, useRegionalConfig } from './hooks/useRegionalConfig';

const RegionSelector: React.FC = () => {
  const [region, setRegion] = useState<IRegionalConfig>();
  const enabledRegions = useRegionalConfig();
  const selectorOptions = enabledRegions.map((region) => {
    return { label: region.label, value: region };
  });

  React.useEffect(() => {
    const currentRegion = enabledRegions.find(
      (r) => r.href === window.location.href
    );
    setRegion(currentRegion);
  }, []);

  const handleRegionChange = (
    selectedOption: SelectOption<IRegionalConfig>
  ): void => {
    if (window.location.href === selectedOption.value.href) return;
    setRegion(selectedOption.value);
  };

  React.useEffect(() => {
    if (region) window.location.href = region.href;
  }, [region]);

  return (
    <SingleSelect
      id="region-selector"
      label="Select Region"
      options={selectorOptions}
      onChange={(e): void => handleRegionChange(e)}
    />
  );
};

export default RegionSelector;
